import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

export type LandingPageForm = {
	isAffirmedIntegrityPolicyCheckbox: boolean;
	isAffirmedMarketingCommunicationCheckbox: boolean;
	campaignId?: string;
	utmCampaign?: string;
	utmSource?: string;
	utmMedium?: string;
	utmTerm?: string;
	utmContent?: string;
	adtractionId?: string;
	googleClickId?: string;
	facebookClickId?: string;
};

export const useLandingPageForm = () => {
	const LandingPageSchema: z.ZodSchema<LandingPageForm> = z.object({
		isAffirmedIntegrityPolicyCheckbox: z.literal(true),
		isAffirmedMarketingCommunicationCheckbox: z.boolean(),
		campaignId: z.string().optional(),
		utmCampaign: z.string().optional(),
		utmSource: z.string().optional(),
		utmMedium: z.string().optional(),
		utmTerm: z.string().optional(),
		utmContent: z.string().optional(),
		adtractionId: z.string().optional(),
		googleClickId: z.string().optional(),
		facebookClickId: z.string().optional(),
	});

	return {
		useForm: useForm<LandingPageForm>({
			resolver: zodResolver(
				LandingPageSchema as unknown as z.ZodType<
					LandingPageForm,
					LandingPageForm
				>
			),
			mode: "onTouched",
			defaultValues: {
				isAffirmedIntegrityPolicyCheckbox: false,
				isAffirmedMarketingCommunicationCheckbox: false,
				campaignId: undefined,
				utmCampaign: undefined,
			},
		}),
		schema: LandingPageSchema,
	};
};
